module.exports = __webpack_public_path__ + "img/new5.5e015f36.png";